import { Controller } from "@hotwired/stimulus"

// Expandable Text Controller
// Toggles text expansion with "더보기" / "간략히" button
//
// Targets:
//   - text: The text content element
//   - button: The toggle button
//   - buttonText: The button text span
//   - icon: The chevron icon
//
// Values:
//   - expanded: Boolean state (default: false)
//   - lineClamp: Number of lines to clamp (default: 3)
//   - showMore: Button text for collapsed state
//   - showLess: Button text for expanded state
export default class extends Controller {
  static targets = ["text", "button", "buttonText", "icon"]
  static values = {
    expanded: { type: Boolean, default: false },
    lineClamp: { type: Number, default: 3 },
    showMore: String,
    showLess: String
  }

  // Toggle expansion state
  // Prevents default and stops propagation to handle clicks inside links
  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.expandedValue = !this.expandedValue
    this.updateUI()
  }

  // Get the line-clamp CSS class based on lineClampValue
  get lineClampClass() {
    return `line-clamp-${this.lineClampValue}`
  }

  // Update UI based on expanded state
  updateUI() {
    if (this.expandedValue) {
      // Expanded state
      this.textTarget.classList.remove(this.lineClampClass)
      this.buttonTextTarget.textContent = this.showLessValue
      this.iconTarget.style.transform = "rotate(180deg)"
    } else {
      // Collapsed state
      this.textTarget.classList.add(this.lineClampClass)
      this.buttonTextTarget.textContent = this.showMoreValue
      this.iconTarget.style.transform = "rotate(0deg)"
    }
  }
}
